export const SET_LANG = "SET_LANG";

export const setLang = (payload) => {
  return {
    type: "SET_LANG",
    payload,
  };
};
